document.addEventListener('DOMContentLoaded', () => {
  // --- Configuration ---
  const netlifyFunctionUrl = 'https://orvizoho.netlify.app/.netlify/functions/product-enquiry'; // Updated URL
  const enquiryButtonId = 'orvi-pe-enquire-now-btn';
  const popupId = 'orvi-pe-enquire-popup';
  const closePopupButtonId = 'orvi-pe-close-popup-btn';
  const formId = 'orvi-pe-product-enquiry-form'; // This ID will be on the form in the Liquid file

  // Global submission tracking
  const submissionTracker = {
    activeSubmissions: new Set(),
    isSubmitting: function (formId) {
      return this.activeSubmissions.has(formId);
    },
    startSubmission: function (formId) {
      this.activeSubmissions.add(formId);
    },
    endSubmission: function (formId) {
      this.activeSubmissions.delete(formId);
    }
  };

  let enquiryButton = document.getElementById(enquiryButtonId);
  let popup = document.getElementById(popupId);
  let closePopupButton = document.getElementById(closePopupButtonId);
  let productEnquiryForm; // Will be assigned when the popup is shown

  // --- Helper: Wait for an element ---
  const waitForElement = (selector, timeout = 5000, baseElement = document) => {
    return new Promise((resolve, reject) => {
      const element = baseElement.querySelector(selector);
      if (element) {
        resolve(element);
        return;
      }
      const observer = new MutationObserver((mutations, obs) => {
        const elementFound = baseElement.querySelector(selector);
        if (elementFound) {
          obs.disconnect();
          resolve(elementFound);
        }
      });
      observer.observe(baseElement, { childList: true, subtree: true });
      setTimeout(() => {
        observer.disconnect();
        reject(new Error(`Element ${selector} not found within ${timeout}ms`));
      }, timeout);
    });
  };

  // --- Initialize Popup and Form ---
  const initializePopup = () => {
    // Simple direct approach

    enquiryButton = document.getElementById(enquiryButtonId);
    popup = document.getElementById(popupId);
    closePopupButton = document.getElementById(closePopupButtonId);

    if (!enquiryButton) {
      return;
    }

    if (!popup) {
      return;
    }

    if (!closePopupButton) {
    } else {
    }

    // Prevent adding multiple listeners if this function is called again
    if (enquiryButton.dataset.listenerAttached === 'true') {
    } else {
      enquiryButton.addEventListener('click', () => {
        if (popup) {
          popup.style.display = 'flex'; // Use flex for align-items/justify-content
          initializeFormListeners();
        } else {
          console.error("[Product Enquiry] Popup element is null when trying to show it.");
        }
      });
      enquiryButton.dataset.listenerAttached = 'true';
    }

    if (closePopupButton) {
      if (closePopupButton.dataset.listenerAttached === 'true') {
      } else {
        closePopupButton.addEventListener('click', () => {
          if (popup) {
            popup.style.display = 'none';
          }
        });
        closePopupButton.dataset.listenerAttached = 'true';
      }
    }

    // Close popup if clicked outside - ensure it only fires if popup is visible
    // And remove previous listener to avoid duplicates if initializePopup is called multiple times
    // However, this is a window listener, so care is needed. Let's assume it's fine for now or manage it more carefully if it becomes an issue.
    // For simplicity, the existing logic is kept but with a visibility check.
    window.addEventListener('click', (event) => {
      if (popup && popup.style.display !== 'none' && event.target === popup) {
        popup.style.display = 'none';
      }
    });
  };

  const initializeFormListeners = async () => {
    if (!popup || popup.style.display === 'none') return; // Only init if popup is visible

    try {
      productEnquiryForm = await waitForElement(`#${formId}`, 2000, popup);
      if (productEnquiryForm && !productEnquiryForm.hasAttribute('data-orvi-handled')) {
        // Generate unique form ID for tracking if not present
        if (!productEnquiryForm.id) {
          productEnquiryForm.id = `product-enquiry-form-${Date.now()}`;
        }

        // Remove any existing event listeners to prevent duplicates
        if (productEnquiryForm._orviSubmitHandler) {
          productEnquiryForm.removeEventListener('submit', productEnquiryForm._orviSubmitHandler);
        }

        // Store handler reference for potential removal later
        productEnquiryForm._orviSubmitHandler = handleFormSubmit;

        // Add event listener directly
        productEnquiryForm.addEventListener('submit', handleFormSubmit);
        productEnquiryForm.setAttribute('data-orvi-handled', 'product-enquiry-script');
      }
    } catch (error) {
    }
  };

  // --- Form Submission Handler ---
  const handleFormSubmit = async (event) => {
    event.preventDefault();
    event.stopImmediatePropagation(); // Prevent other handlers from executing

    if (!productEnquiryForm) return;

    const formId = productEnquiryForm.id;

    // Check if already submitting
    if (submissionTracker.isSubmitting(formId)) {
      return; // Already submitting, ignore this request
    }

    // Start tracking submission
    submissionTracker.startSubmission(formId);

    // Disable form interactions during submission
    productEnquiryForm.style.pointerEvents = 'none';

    const submitButton = productEnquiryForm.querySelector('button[type="submit"], input[type="submit"]');
    const originalButtonText = submitButton ? (submitButton.innerHTML || submitButton.value) : 'Submit';

    // --- Get Form Data ---
    const firstNameField = productEnquiryForm.querySelector('input[name="contact[first_name]"]');
    const lastNameField = productEnquiryForm.querySelector('input[name="contact[last_name]"]');
    const emailField = productEnquiryForm.querySelector('input[name="contact[email]"]');
    const phoneField = productEnquiryForm.querySelector('input[name="contact[phone]"]');
    const messageField = productEnquiryForm.querySelector('textarea[name="contact[body]"]');
    const productNameField = productEnquiryForm.querySelector('input[name="contact[product_name]"]');
    const sourcePageField = productEnquiryForm.querySelector('input[name="contact[source_page]"]');

    // Basic validation for presence of fields (Liquid should ensure they exist)
    if (!firstNameField || !lastNameField || !emailField || !phoneField || !productNameField || !sourcePageField) {
      console.error('Form is missing critical fields. Please contact support.');
      submissionTracker.endSubmission(formId);
      productEnquiryForm.style.pointerEvents = '';
      return;
    }

    const formData = {
      firstName: firstNameField.value.trim(),
      lastName: lastNameField.value.trim(),
      email: emailField.value.trim(),
      phone: phoneField.value.trim(),
      message: messageField ? messageField.value.trim() : '',
      productName: productNameField.value.trim(),
      sourcePage: sourcePageField.value.trim(),
      leadSource: 'OHEnquiry',
      sourceByGroup: 'OHEnquiry'
    };

    // --- Client-Side Validation ---
    const missingRequiredFields = [];
    if (!formData.firstName) missingRequiredFields.push('First Name');
    if (!formData.lastName) missingRequiredFields.push('Last Name');
    if (!formData.email) missingRequiredFields.push('Email');
    if (!formData.phone) missingRequiredFields.push('Phone');
    if (!formData.productName) missingRequiredFields.push('Product Name (auto-filled)'); // Should be auto-filled
    if (!formData.sourcePage) missingRequiredFields.push('Source Page (auto-filled)'); // Should be auto-filled

    if (missingRequiredFields.length > 0) {
      console.error(`Missing required fields: ${missingRequiredFields.join(', ')}`);
      submissionTracker.endSubmission(formId);
      productEnquiryForm.style.pointerEvents = '';
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      console.error('Invalid email address entered.');
      submissionTracker.endSubmission(formId);
      productEnquiryForm.style.pointerEvents = '';
      return;
    }

    // --- UI Feedback: Loading State ---
    if (submitButton) {
      submitButton.disabled = true;
      if (submitButton.tagName === 'BUTTON') submitButton.innerHTML = 'Sending...';
      else submitButton.value = 'Sending...';
    }

    // --- API Call ---
    try {
      const response = await fetch(netlifyFunctionUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData),
      });

      let result;
      try {
        result = await response.json();
      } catch (parseError) {
        console.error("Failed to parse server response:", parseError);
        throw new Error('Invalid response from server. Please try again.');
      }

      if (response.ok && result.success) {
        // --- UI Feedback: Success State ---
        if (submitButton) {
          if (submitButton.tagName === 'BUTTON') submitButton.innerHTML = 'Sent!';
          else submitButton.value = 'Sent!';
        }

        // Show success message to user
        if (result.duplicate) {
          alert('Your product enquiry has already been submitted!');
        } else {
          alert('Thank you! Your product enquiry has been submitted successfully.');
        }

        productEnquiryForm.reset();

        if (popup) popup.style.display = 'none'; // Close popup on success

      } else {
        // --- UI Feedback: Error State from Server ---
        console.error("Server error:", result.error, "Details:", result.details);
        alert('There was an error submitting your product enquiry. Please try again later.');
      }
    } catch (error) {
      // --- UI Feedback: Network/Client-Side Error State ---
      console.error("Network or client-side error:", error);
      alert('Network error. Please check your connection and try again.');
    } finally {
      // --- Reset form state and button ---
      productEnquiryForm.style.pointerEvents = ''; // Re-enable form interactions
      submissionTracker.endSubmission(formId); // End submission tracking

      if (submitButton) {
        setTimeout(() => {
          if (submitButton.tagName === 'BUTTON') submitButton.innerHTML = originalButtonText;
          else submitButton.value = originalButtonText;
          submitButton.disabled = false;
        }, 2000); // Delay to show "Sent!"
      }
    }
  };

  // --- Initial Setup ---
  // Use a small delay to ensure all DOM elements including the popup structure are loaded
  setTimeout(() => {
    initializePopup();
  }, 500);

  // Fallback if elements are added dynamically later
  let observerTimeout;
  const observer = new MutationObserver((mutationsList, obs) => {
    // Debounce the reinitialization to prevent excessive calls
    clearTimeout(observerTimeout);
    observerTimeout = setTimeout(() => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const currentEnquiryButton = document.getElementById(enquiryButtonId);
          // If button appears and listener not yet attached
          if (currentEnquiryButton && !currentEnquiryButton.dataset.listenerAttached) {
            initializePopup();
          }

          // Logic for initializing form listeners if popup becomes visible and form isn't initialized
          // Ensure popup is defined and visible (now checking for 'flex')
          const currentPopup = document.getElementById(popupId);
          if (currentPopup && currentPopup.style.display === 'flex') {
            const formElement = currentPopup.querySelector(`#${formId}`);
            if (formElement && !formElement.getAttribute('data-orvi-handled')) {
              initializeFormListeners(); // This function already checks if popup is visible
            }
          }
        }
      }
    }, 300); // 300ms debounce delay
  });

  observer.observe(document.body, { childList: true, subtree: true });
});